import { components } from "./schemas";

// import generated schemas
type schemas = components["schemas"];

export type StatusFilterModel = schemas["StatusFilterModel"];

export type ClientViewModel = schemas["ClientViewModel"];
export type ClientModel = schemas["ClientModel"];
export type ClientContactModel = schemas["ClientContactModel"];
export type ClientNoteModel = schemas["ClientNoteModel"];
export type ClientEditTab = schemas["ClientEditTab"];

export type ProjectViewModel = schemas["ProjectViewModel"];
export type ProjectModel = schemas["ProjectModel"];
export type NameModel = schemas["NameModel"];
export type ProjectApplicationModel = schemas["ProjectApplicationModel"];
export type ProjectLinkModel = schemas["ProjectLinkModel"];
export type ProjectGridFilterModel = schemas["ProjectGridFilterModel"];

export type ExternalTrackerModel = schemas["ExternalTrackerModel"];

export type TaskPullRequestModel = schemas["TaskPullRequestModel"];

export type TaskModel = schemas["TaskModel"];
export type TaskEditModel = schemas["TaskEditModel"];
export type TaskViewModel = schemas["TaskViewModel"];
export type TaskFilterModel = schemas["TaskFilterModel"];

export const DevOpsRepositoryPlatform = 0;
export const GitHubRepositoryPlatform = 1;
export type RepositoryPlatform = schemas["RepositoryPlatform"];

export const DefaultFullReportExportType = 1; // FullReportExportType.Combined
export type FullReportExportType = schemas["FullReportExportType"];

export type NotificationModel = schemas["NotificationModel"];

export type TimeChargeModel = schemas["TimeChargeModel"];
export type TimeEntryGridFilterModel = schemas["TimeEntryGridFilterModel"];
export type TimeEntryGridModel = schemas["TimeEntryGridModel"];
export type ExternalTaskModel = schemas["ExternalTaskModel"];
export type TaskFeedbackModel = schemas["TaskFeedbackModel"];
export type TaskHoursModel = schemas["TaskHoursModel"];
export type TaskRelatedModel = schemas["TaskRelatedModel"];
export type TaskToDoModel = schemas["TaskToDoModel"];

export type TimeEntryReportModel = schemas["TimeEntryReportModel"];
export type TimeEntrySummaryReportModel =
    schemas["TimeEntrySummaryReportModel"];

export type UserModel = schemas["UserModel"];
export type AsanaConfigurationModel = schemas["AsanaConfigurationModel"];
